import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryFaxNumber } from "./DirectoryFaxNumber";
import { DirectoryPhoneNumber } from "./DirectoryPhoneNumber";
import { IDirectoryEntity } from "./IDirectoryEntity";

export interface IDirectoryFaxInfo {
    name?: string,
    address?: string,
    faxNumber: DirectoryFaxNumber
}

export class DirectorySelectableEntity<TModel extends IDirectoryEntity> {
    public id: string;
    public type: DirectoryEntityType;
    public name?: string;
    public address: string;
    public phoneNumbers?: DirectoryPhoneNumber[];
    public faxInfos: IDirectoryFaxInfo[];
    public model?: TModel;
    public isInvalid?: boolean;

    public constructor(init?: Partial<DirectorySelectableEntity<TModel>>) {
        Object.assign(this, init);
    }
}
